const routes = [
    {
        path: "/osymcodes",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "osymcode_index"
        }
    },
];

export default routes;
